<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-input placeholder="讲师姓名"  v-model="search.key" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 20%;  " ></el-input>
    <el-table :data="teacher_list.data" stripe style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}">
      <el-table-column prop="num" label="编号" sortable>
      </el-table-column>
      <el-table-column label="图片" sortable>
        <template slot-scope="scope">
          <img :src="teacher_list.data[scope.$index].img" width="100px"/>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" sortable>
      </el-table-column>
      <el-table-column prop="name" label="操作" >
        <template slot-scope="scope">
      <!--  <i class="el-icon-view"></i> -->
      <el-button plain size="mini" @click="see_details(scope)">详情</el-button>
      </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="teacher_list.current_page" :page-sizes="[5,10, 20, 30, 40]" :page-size="teacher_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="teacher_list.total">
      </el-pagination>
    </div>
    <el-dialog title="讲师详情"   :visible.sync="details.show" >
      <div style="display: flex;">
        <div style="flex: 1;">
          <img :src="details.list.img" width="100%"/>
        </div>
        <div style="flex: 2;padding-left: 15px;">
          <div v-html="details.list.name" style="margin-top:20px;"></div>
          <div v-html="details.list.content" style="margin-top:20px;"></div>
          <div v-html="details.list.info" style="margin-top:20px;"></div>
        </div>
      </div>


       <div slot="footer" class="dialog-footer">
        <el-button @click="details.show = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:'',
        teacher_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 5,
        },
        search: {
          key:'',
        },
        details:{
          show:false,
          list:{},
        },
      }
    },
    components: {load:load},

    mounted:function(){
      this.get_teacher();
    },

    methods: {
      search_click(){
        this.get_teacher()
      },

      get_teacher(){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_resource/get_teacher',{params:{'page':_this.teacher_list.current_page,'limit':_this.teacher_list.per_page,'type':'0','keyword':_this.search.key}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.teacher_list=res.data.data
              _this.teacher_list.per_page=parseInt(_this.teacher_list.per_page)
              _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.teacher_list.current_page = 1;
        this.teacher_list.per_page = val;
        this.get_teacher();
      },
      handleCurrentChange(val) {
        let _this=this
        _this.teacher_list.current_page = val;
        _this.get_teacher();
      },
      see_details(item){
        let _this=this
        _this.details.show=true
        _this.details.list=item.row


      },
      determine(){
        let _this =this
        _this.details.show=false
      }
    }
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/course/YzCourse/Teacher.vue